export const FileUploadErrors = {
  FILE_TOO_LARGE: {
    title: 'inventory.uploadComponent.error.fileTooLargeTitle',
    subtitle: 'inventory.uploadComponent.error.fileTooLargeSubtitle',
  },
  INVALID_FORMAT: {
    title: 'inventory.uploadComponent.error.invalidFormatTitle',
    subtitle: 'inventory.uploadComponent.error.invalidFormatSubtitle',
  },
  UPLOAD_FAILED: {
    title: 'inventory.uploadComponent.error.uploadFailedTitle',
    subtitle: 'inventory.uploadComponent.error.uploadFailedSubtitle',
  },
  EXPORT_FAILED: {
    title: 'inventory.uploadComponent.error.exportFailedTitle',
    subtitle: 'inventory.uploadComponent.error.exportFailedSubtitle',
    message: 'inventory.uploadComponent.error.exportFailedMessage',
  },
};
